import { Component, OnInit, ViewChild } from '@angular/core';
import { OrganizationsService } from './organizations.service';
import { Organization } from '../shared/models/organization.model';
import { faUserPlus, faSearchPlus, faEdit, faTrashAlt, faHeart } from '@fortawesome/free-solid-svg-icons';
import { ConfirmModalComponent } from '../shared/confirm-modal/confirm-modal.component';
import { ConfirmModalService } from '../shared/confirm-modal/confirm-modal.service';
import { environment } from 'src/environments/environment';
import { SharedService } from '../shared/shared.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-organizations',
    templateUrl: './organizations.component.html',
    styleUrls: ['./organizations.component.css'],
    standalone: false
})
export class OrganizationsComponent implements OnInit {

  @ViewChild('confirmModal') confirmModal: ConfirmModalComponent;

  public icons: { [name: string]: any } = {
    'faUserPlus': faUserPlus,
    'faSearchPlus': faSearchPlus,
    'faEdit': faEdit,
    'faTrashAlt': faTrashAlt,
    'faHeart': faHeart
  };

  public currentLanguage: string;
  public organizations: Organization[] = [];
  public imagePath = environment.imageUrl;
  constructor(private _organizationsService: OrganizationsService, private _confirmModalService: ConfirmModalService,
    private _sharedService: SharedService, private _translateService: TranslateService) { }

  ngOnInit(): void {
    this.currentLanguage = this._translateService.getDefaultLang();
    localStorage.removeItem('orgId');
    this._sharedService.organizationNameSubject.next(undefined);
    this._organizationsService.getOrganizations().subscribe(result => {
      this.organizations = result;
    });

    this._translateService.onLangChange.subscribe(result => {
      this.currentLanguage = result.lang;
    });
  }


  onElementDelete(organizationId: number) {
    this.confirmModal.open('Delete Organization', 'Do you want to delete this organization?');
    this.confirmModal.confirmationResult.subscribe(result => {
      console.log(result);
      if (result) {
        console.log('DELETE');
      }
    });
  }

}
